import { getKyClient } from './client';

export const fetchSsoGroups = async () => {
  let url = `v1/SsoGroup`;

  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};
export const fetchSsoGroup = async (ssoGroupId) => {
  let url = `v1/SsoGroup/${ssoGroupId}`;

  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};
export const fetchSsoRoles = async () => {
  let url = `v1/SsoGroup/Roles`;

  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const deleteSsoGroup = async (ssoGroupId) => {
  let url = `v1/SsoGroup/${ssoGroupId}`;

  const kyClient = await getKyClient();
  return kyClient.delete(url).json();
};

export const updateSsoGroup = async ({
  ssoGroupId,
  name,
  groupExternalId,
  description,
  permissions,
}) => {
  let url = `v1/SsoGroup/` + ssoGroupId;
  const kyClient = await getKyClient();
  return kyClient.put(url, {
    json: { name, groupExternalId, description, permissions },
  });
};
export const addSsoGroup = async (ssoGroupDetail) => {
  const url = `v1/SsoGroup`;
  const kyClient = await getKyClient();
  return kyClient
    .post(url, {
      json: ssoGroupDetail,
    })
    .json();
};
